import { Component, Inject } from '@angular/core';
import { AppointmentRequest } from '../../../shared/models/appointment-request.model';
import { AppointmentRequestsService } from '../appointment-requests.service';
import * as appointmentRequestsActions from '../appointment-requests.actions';
import { Group } from '../../../shared/models/group.model';
import { Store } from '@ngrx/store';
import { AppState } from '../../../app.state';

@Component({
  selector: 'cancelled-appointment-requests',
  styles: [require('./cancelled-appointment-requests.component.scss')],
  template: require('./cancelled-appointment-requests.component.html'),
})

export class CancelledAppointmentRequestsComponent {
  cancelledAppointmentRequests: AppointmentRequest[];
  group: Group;

  public mobileCharacterLimit = 85;

  constructor(
    @Inject('$ngRedux') public $ngRedux: any,
    @Inject('$state') public $state: any,
    @Inject('$translate') public $translate: any,
    public AppointmentRequestsService: AppointmentRequestsService,
    private store: Store<AppState>,
  ) { }

  ngOnInit() {
    this.group = this.$ngRedux.getState().group;
    const patientId = this.$ngRedux.getState().currentPatient.id;
    this.AppointmentRequestsService.get(this.group.id, patientId, 'cancelled')
      .subscribe(
        (data) => {
          this.cancelledAppointmentRequests = data;
        },
        err => undefined,
      );
  }

  getCancellationReason(cancelledAppointmentRequest) {
    return cancelledAppointmentRequest.cancellationReason || '-';
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/home/appointment-requests/cancelled-appointment-requests/cancelled-appointment-requests.component.ts